export const getTableScroll = (columns, showPrior180, showPrior90, showPrior30) => {
  const EST_BASE_WIDTH = 1150, SHOW_PRIOR_COL_WIDTH = 80, EST_PADDING = 30;

  const hiddenWidth =
    [!showPrior180, !showPrior90, !showPrior30].filter(Boolean).length * SHOW_PRIOR_COL_WIDTH;

  const estWidth = EST_BASE_WIDTH - hiddenWidth;

  const actualWidth = columns.reduce((sum, col) => sum + (col.width || 0) + EST_PADDING, 0);

  return { x: actualWidth < estWidth ? actualWidth : estWidth };
};

export const parseBoolParam = (value, defaultValue) => {
  if (value == null) return defaultValue;
  return value.toLowerCase() === "true";
};
